<!-- <mat-toolbar color="primary" class="footer-toolbar">
  <div class="footer-content">
    <span>© 2025 Nidal Group. All Rights Reserved.</span>  
  </div>
</mat-toolbar> -->

<footer class="vendor-footer">
  <div class="footer-content">
    <div class="vendor-logos">
      <img src="vendor3.jpeg" alt="Vendor 3" />
      <img src="vendor4.jpeg" alt="Vendor 4" />
      <img src="vendor2.jpeg" alt="Vendor 2" />
      <img src="vendor1.jpeg" alt="Vendor 1" />
    </div>
    <div class="footer-bottom">
      2025 Nidal Group. All rights reserved..
    </div>
  </div>
</footer>